<template lang="pug">
.flex
  .date {{ formattedSelectedDate }}
  .date-picker-holder.flex
    BriqDateTimePicker(
      name="planboardDate"
      id="planboardDate"
      :value="selectedDate"
      autocomplete="off"
      data-test-id="planboard-selected-date"
      @input="setSelectedDateAndNavigate"
      :showInput="false"
      :positionCalendarToElement="calendarButtonId"
      )
    button.date-picker-button.arrow-button(@click="setPlanboardDateToPreviousDay()")
      BriqIcon(name="icon-arrow-leftright-icon")
    button.date-picker-button.calendar-button(@click="openDatePicker" :id="calendarButtonId")
      BriqIcon(name="icon-calendar" customStyle="vertical-align: middle;")
    button.date-picker-button.arrow-button.rotate180(@click="setPlanboardDateToNextDay()")
      BriqIcon(name="icon-arrow-leftright-icon" :customStyle="iconsInTheMiddle")
</template>
<script>
import { mapActions, mapState } from 'vuex'
import { format } from 'date-fns'
import {
  getShortDateForGivenFormatIgnoringTimezone,
  getLocaleDateFormatString,
  convertDateToUTCDate,
} from '@/helpers/dateTimeFormatter.js'
import BriqDateTimePicker from '@/vue/components-global/BriqDateTimePicker.vue'

export default {
  name: 'PlanboardDatePicker',
  components: { BriqDateTimePicker },
  data() {
    return {
      iconsInTheMiddle: 'margin-top: -4px;',
      calendarButtonId: 'calendar-button',
    }
  },
  computed: {
    ...mapState('planboardModule', ['selectedDate']),
    formattedSelectedDate() {
      return getShortDateForGivenFormatIgnoringTimezone({
        date: this.selectedDate,
        dateFormat: getLocaleDateFormatString(this.$locale),
      })
    },
  },
  methods: {
    ...mapActions('planboardModule', ['setSelectedDate', 'fetchPlanboardData']),
    setPlanboardDateToNextDay() {
      this.setDirectionDateAndNavigate('next')
    },
    setPlanboardDateToPreviousDay() {
      this.setDirectionDateAndNavigate('prev')
    },
    setDirectionDateAndNavigate(direction) {
      const currentDate = convertDateToUTCDate(this.selectedDate)
      const nextDate = direction === 'next' ? currentDate.getDate() + 1 : currentDate.getDate() - 1
      currentDate.setDate(nextDate)
      this.setSelectedDate(currentDate)
      this.$router.push({
        name: 'Planboard',
        params: {
          selectedDate: format(currentDate, 'yyyy-MM-dd'),
        },
      })
    },
    setSelectedDateAndNavigate(date) {
      const utcDate = convertDateToUTCDate(date)
      if (!date) return
      this.setSelectedDate(utcDate)
      this.$router.push({
        name: 'Planboard',
        params: { selectedDate: date },
      })
    },
    openDatePicker() {
      this.$emit('openDatePicker')
    },
  },
}
</script>

<style scoped lang="stylus">
@import '~@v/variables.styl'

.date
  font-weight 600
  font-size 32px
  line-height 38px
  margin-right 10px

.date-picker-holder
  height 40px

.arrow-button
  border 1px solid borderColor
  display block
  padding 7px
  border-radius 5px 0px 0px 5px
  margin-left -1px
  margin-right -1px

.calendar-button
  border 1px solid borderColor
  display block
  padding-left 15px
  padding-right 15px

.rotate180
  transform rotate(180deg)

.date-picker-button:hover
  border-color grey400
  z-index 2
</style>
